<template>
  <UiSelect
    v-model="sortBy"
    :items="sortOptions"
    name="sortBy"
    hide-details
    dropdown-classes="w-45.5"
  >
    <template #activator="{ selectedItem, open }">
      <button class="relative flex items-center gap-1.5 text-xs uppercase">
        <span class="inline-flex items-center"> {{ $t("sort") }} </span>
        <span v-if="selectedItem" class="flex flex-auto items-center">
          ({{
            Array.isArray(selectedItem)
              ? selectedItem.map((item) => item?.label).join(", ")
              : selectedItem.label
          }})
        </span>
        <UiIcon
          :name="open ? 'chevron_up' : 'chevron_down'"
          class="pointer-events-none size-6 flex-shrink-0"
        />
      </button>
    </template>
    <template #item="{ item, selected }">
      <span
        class="inline-flex w-full items-center gap-2 text-xs font-light"
        :data-e2e-item="dataE2eSort(item)"
      >
        <UiIcon
          :name="selected ? 'radio-checked' : 'radio-unchecked'"
          class="size-5"
        />
        {{ item.label }}
      </span>
    </template>
  </UiSelect>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{ btnClasses?: string; isEngagement?: boolean }>(),
  {
    btnClasses: "",
    isEngagement: false,
  },
);
const { sortOptions, sortBy } = useCatalogFilters({
  isEngagement: props.isEngagement,
});
defineEmits(["onChangeSort"]);

function dataE2eSort(item) {
  switch (item.value) {
    case "defaultAsc":
      return "sorting-default";
    case "priceDesc":
      return "sorting-price-desc";
    case "priceAsc":
      return "sorting-price-asc";
    default:
      return null;
  }
}
</script>
